import styled from 'styled-components';

export const Container = styled.button`
  background: #fff;
  border: 1px solid #ced4da;
  border-radius: 8px;
  overflow: hidden;
  padding: 12px;
  text-align: left;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  cursor: pointer;
  transition: box-shadow 0.2s ease, transform 0.2s ease;

  &:hover {
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }

  .thumb {
    position: relative;
    width: 100%;
    padding-top: 52%;
    background: #01080c center/cover no-repeat;
    border-radius: 6px;
    overflow: hidden;
  }

  .thumb img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .play-overlay {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.25);
    opacity: 0;
    transition: opacity 0.2s ease;
  }

  &:hover .play-overlay {
    opacity: 1;
  }

  .play-overlay .material-icons {
    color: #fff;
    font-size: 48px;
  }

  .body {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .title {
    font-size: 0.95rem;
    font-weight: 700;
    color: #212529;
    margin-bottom: 4px;
    line-height: 1.3;
  }

  .subtitle {
    font-size: 0.8rem;
    font-weight: 400;
    color: #6c757d;
    margin-bottom: 12px;
  }

  .type-pill {
    align-self: flex-start;
    margin-top: auto;
    background: #f1f1f1;
    border: 1px solid #ced4da;
    color: #000;
    font-size: 0.78rem;
    font-weight: 700;
    padding: 3px 14px;
    border-radius: 20px;
  }
`;
